<template>
  <div class="admin-home">
    <div style="position: relative">
      <left-menu :menus="items" userType="admin" ref="leftMenuRef" />
      <div @click="toggleCollapsed" class="toggle-menu">
        <svg class="icon" aria-hidden="true">
          <use :xlink:href="'#icon-' + (collapsed ? 'zhankai' : 'shouqi')" />
        </svg>
      </div>
    </div>
    <div class="wrap">
      <topBar />
      <div class="content">
        <div class="page">
          <router-view />
        </div>
        <div class="footer">
          <Footer />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="jsx">
import { h, reactive, ref, onMounted, onBeforeMount } from 'vue'
import leftMenu from '~/components/LeftMenu.vue'
import topBar from '~/components/topBar.vue'
import Footer from '~/components/Footer.vue'
import { financeApi } from '~/server/operator/finance'
const leftMenuRef = ref(null)
const collapsed = ref(false)
const toggleCollapsed = () => {
  collapsed.value = !collapsed.value
  leftMenuRef.value.toggleCollapsed()
}
const counts = ref({
  pendingCount: 0,
})
const items = reactive([
  {
    key: '/operator/users',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-home' }),
      ]),
    routeName: 'users',
    title: 'Users',
    label: 'Users',
  },
  {
    key: '/operator/menu',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-a-shezhi2' }),
      ]),
    routeName: 'menu',
    title: 'Menu',
    label: 'Menu',
  },
  {
    key: '/operator/seller',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-shangjia' }),
      ]),
    routeName: 'seller',
    title: 'Sellers',
    label: 'Sellers',
  },

  {
    key: '/operator/publisher',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-a-wode4' }),
      ]),
    routeName: 'publisher',
    title: 'Publisher',
    label: 'Publisher',
  },
  {
    key: '/operator/reports',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-chart' }),
      ]),
    routeName: 'reports',
    title: 'Reports',
    label: 'Reports',
    children: [
      {
        routeName: 'reports-performance',
        key: '/operator/reports/performance',
        preKey: '/operator/reports',
        label: 'Performance',
        title: 'Performance',
      },
      {
        routeName: 'reports-product',
        key: '/operator/reports/product',
        preKey: '/operator/reports',
        label: 'Product',
        title: 'Product',
      },
      {
        routeName: 'reports-brand',
        key: '/operator/reports/brand',
        preKey: '/operator/reports',
        label: 'Brand',
        title: 'Brand',
      },
      {
        routeName: 'reports-publisher',
        key: '/operator/reports/publisher',
        preKey: '/operator/reports',
        label: 'Publisher',
        title: 'Publisher',
      },
      {
        key: '/operator/reports/report',
        routeName: 'reports-report',
        preKey: '/operator/reports',
        title: "Sellers' 30D Report",
        label: "Sellers' 30D Report",
      },
    ],
  },
  {
    key: '/operator/commissions',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-baifenhao' }),
      ]),
    routeName: 'commissions',
    title: 'Commissions',
    label: 'Commissions',
  },
  {
    key: '/operator/operation',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-a-PaidPlacement' }),
      ]),
    routeName: 'operation',
    label: 'Operation',
    title: 'Operation',
    children: [
      {
        routeName: 'operation-productsExport',
        preKey: '/operator/operation',
        key: '/operator/operation/productsExport',
        label: 'Products Export',
        title: 'Products Export',
      },
      
      {
        routeName: 'operation-manualPayments',
        preKey: '/operator/operation',
        key: '/operator/operation/manualPayments',
        label: 'Manual Payments',
        title: 'Manual Payments',
      },
      {
        routeName: 'operation-dealsInfo',
        preKey: '/operator/operation',
        key: '/operator/operation/dealsInfo',
        label: 'Deals Info',
        title: 'Deals Info',
      },
      {
        routeName: 'operation-sensitive',
        preKey: '/operator/operation',
        key: '/operator/operation/sensitive',
        label: 'Sensitive Products',
        title: 'Sensitive Categories',
      },
      //      {
      //   key: "/operator/submittedDeals",
      //  preKey: "/operator/operation",
      //   routeName: "operation-submittedDeals",
      //   title: "Submitted Deals",
      //   label: "Submitted Deals",
      // },
      {
        routeName: 'operation-submittedDeals',
        preKey: '/operator/operation',
        key: '/operator/operation/submittedDeals',
        label: 'Submitted Deals',
        title: 'Submitted Deals',
      },
      {
        routeName: 'operation-accBonusPrograms',
        preKey: '/operator/operation',
        key: '/operator/operation/accBonusPrograms',
        label: 'Acc Bonus Programs',
        title: 'Acc Bonus Programs',
      },
      {
        routeName: 'operation-creatorConnections',
        key: '/operator/operation/creatorConnections',
        preKey: '/operator/operation',
        label: 'Amazon CC Authorization',
        title: 'Amazon CC Authorization',
      },
      {
        routeName: 'operation-sensitiveProducts',
        preKey: '/operator/operation',
        key: '/operator/operation/sensitiveProducts',
        label: 'Associate Partnerships',
        title: 'Associate Partnerships',
      },
      {
        routeName: 'operator-operation-sellerLogs-associateReports',
        key: '/operator/operation/sellerLogs/associateReports',
        label: 'Associate Reports',
        title: 'Associate Reports',
      },
     
      {
        routeName: 'operation-sellerLogs',
        preKey: '/operator/operation',
        key: '/operator/operation/sellerLogs',
        label: 'Seller Logs',
        title: 'Seller Logs',
        children: [
          {
            routeName: 'operator-operation-sellerLogs-attribution',
            preKey: '/operator/operation/sellerLogs',
            key: '/operator/operation/sellerLogs/attribution',
            label: 'Attribution',
            title: 'Attribution',
          },
          {
            routeName: 'operator-operation-sellerLogs-associate',
            preKey: '/operator/operation/sellerLogs',
            key: '/operator/operation/sellerLogs/associate',
            label: 'Associate',
            title: 'Associate',
          },

        ]
      }
      // {
      //   key: '/operator/creatorConnections',
      //   icon: () =>
      //     h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
      //       h('use', { 'xlink:href': '#icon-baifenhao' }),
      //     ]),
      //   routeName: 'creatorConnections',
      //   title: 'Creator Connections',
      //   label: 'Creator Connections',
      //   children: [

      //   ],
      // },
    ],
  },
  {
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-a-PaidPlacement' }),
      ]),
    routeName: 'paidPlacement',
    key: '/operator/paidPlacement',
    label: (
      <div class="reports-beta-tag">
        Paid Placement
        <div className="unread-badge">{counts.value?.pendingCount}</div>
      </div>
    ),
    title: 'Paid Placement',
    children: [
      {
        routeName: 'paidPlacement-placement',
        key: '/operator/paidPlacement/placement',
        label: 'Placements',
        title: 'Placements',
      },
      {
        routeName: 'paidPlacement-campaigns',
        key: '/operator/paidPlacement/campaigns',
        label: 'Campaigns',
        title: 'Campaigns',
      },
    ],
  },
  {
    key: '/operator/finance',
    icon: () =>
      h('svg', { class: 'icon', 'aria-hidden': 'true' }, [
        h('use', { 'xlink:href': '#icon-jine' }),
      ]),
    label: 'Finance',
    children: [
      {
        routeName: 'finance-payments',
        key: '/operator/finance/payments',
        preKey: '/operator/finance',
        label: 'Payments',
        title: 'Payments',
      },
      {
        routeName: 'finance-ar',
        key: '/operator/finance/ar',
        preKey: '/operator/finance',
        label: 'AR',
        title: 'AR',
      },
      {
        routeName: 'finance-newPay',
        key: '/operator/finance/newPay',
        preKey: '/operator/finance',
        label: 'Receipt Breakdowns',
        title: 'Receipt Breakdowns',
      },
      {
        routeName: 'finance-publishersPaymentInfo',
        preKey: '/operator/finance',
        key: '/operator/finance/publishersPaymentInfo',
        label: 'Publishers Payment Info',
        title: 'Publishers Payment Info',
      },
      {
        routeName: 'finance-publisherPayoutData',
        preKey: '/operator/finance',
        key: '/operator/finance/publisherPayoutData',
        label: 'Publisher Payout Data',
        title: 'Publisher Payout Data',
      },
      // {
      //   preKey: "/operator/finance",
      //   routeName: "finance-transactions",
      //   key: "/operator/finance/transactions",
      //   label: "Transactions",
      //   title: "Transactions",
      // },
      // {
      //   preKey: "/operator/finance",
      //   routeName: "finance-manually-actions",
      //   key: "/operator/finance/manually-actions",
      //   label: "Manually Actions",
      //   title: "Manually Actions",
      // },
      // {
      //   preKey: "/operator/finance",
      //   routeName: "finance-saas-plan",
      //   key: "/operator/finance/saas-plan",
      //   label: "SAAS Plan",
      //   title: "SAAS Plan",
      // },
    ],
  },

  // {
  //   key: "/operator/creatorConnections",
  //    icon: () =>
  //     h("svg", { class: "icon", "aria-hidden": "true" }, [
  //       h("use", { "xlink:href": "#icon-baifenhao" }),
  //     ]),
  //   routeName: "creatorConnections",
  //   title: "Creator Connections",
  //   label: "Creator Connections",
  //    children: [
  //     {
  //       routeName: 'creatorConnections-creatorConnections',
  //       key: '/operator/creatorConnections',
  //       preKey: "/operator/creatorConnections",
  //       label: 'Amazon CC Authorization',
  //       title: 'Amazon CC Authorization',
  //     }
  //    ]
  // }
])
const link =
  document.querySelector("link[rel*='icon']") || document.createElement('link')
link.type = 'image/x-icon'
link.rel = 'shortcut icon'
link.href = '/admads-favicon.png'
document.getElementsByTagName('head')[0].appendChild(link)
const getCount = async () => {
  const data = await financeApi.getFinancePlacementCount()
  counts.value = data
  items[7].label = (
    <div class="reports-beta-tag">
      Paid Placement
      <div className="unread-badge">
        {counts.value?.pendingCount > 99 ? '99+' : counts.value?.pendingCount}
      </div>
    </div>
  )
}
getCount()
onBeforeMount(async () => {
  await getCount()
})
</script>
<style lang="less">
.artmisads-button.artmisads-default {
  border-width: 1px !important;
}
</style>
<style lang="less" scoped>
.toggle-menu {
  top: 10px;
  z-index: 999;
  width: 24px;
  right: -24px;
  height: 28px;
  cursor: pointer;
  position: absolute;
  background: #ffffff;
  border: 1px solid var(--border-4);
  box-shadow: 0 1px 0 0 var(--box-shadow-2);
  border-radius: 0 8px 8px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--dark-3);

  .icon {
    font-size: 12px;
    font-weight: 600;
  }

  &:hover {
    color: var(--dark-3);
    background-color: var(--bg-gray-1);
    border-color: var(--border-1);
  }

  &:active {
    color: var(--dark-2);
    background-color: var(--bg-gray-2);
    border-color: var(--bg-gray-7);
  }
}

:deep(.ant-menu-title-content) {
  overflow: visible !important;

  .reports-beta-tag {
    position: relative;

    .unread-badge {
      position: absolute;
      top: 0px;
      right: -5px;
      background: #eb4e3d;
      color: white;
      border-radius: 20px;
      min-width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      font-family: 'Sora';
      font-size: 14.4px;
      font-style: normal;

      line-height: 14.4px;
      font-weight: 600;
    }
  }
}

.admin-home {
  display: flex;
  width: 100dvw;
  height: 100dvh;
  // overflow: hidden;
  // min-width: 1440px;
  overflow-x: scroll;
  overflow-y: scroll;
  background-color: #f3f2f7;

  .wrap {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 1176px;
    background-color: #f3f2f7;

    .content {
      flex: 1;
      overflow: auto;

      .page {
        min-height: calc(100% - 72px);
      }
    }
  }
}
</style>
